/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetAvailableAccessRights$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAvailableAccessRightsRequest = createAction<PayloadData<void>>('GET_AVAILABLE_ACCESS_RIGHTS__GET_AVAILABLE_ACCESS_RIGHTS__REQUEST');
export const getAvailableAccessRightsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_AVAILABLE_ACCESS_RIGHTS__GET_AVAILABLE_ACCESS_RIGHTS__SUCCESS');
export const getAvailableAccessRightsFailure = createAction<PayloadData<Error, void, true>>('GET_AVAILABLE_ACCESS_RIGHTS__GET_AVAILABLE_ACCESS_RIGHTS__FAILURE');

export const getAvailableAccessRightsActions = [
    getAvailableAccessRightsRequest,
    getAvailableAccessRightsSuccess,
    getAvailableAccessRightsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAvailableAccessRights = (config?: GetAvailableAccessRights$Config) => {
    return {
        CALL_API: {
            types: getAvailableAccessRightsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/access-rights`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

